import React from 'react';
import { Box, Skeleton } from '@mui/material';

const ActivityLogsSkeleton = () => {
  return (
    <Box sx={{ padding: '20px' }}>
      {/* Title */}
      <Skeleton variant="text" width="30%" height={40} animation="wave" />
      <Skeleton variant="text" width="50%" height={20} animation="wave" sx={{ mb: 3 }} />

      {/* User info header */}
      <Box display="flex" alignItems="center" gap={2} mb={4}>
        <Skeleton variant="circular" width={50} height={50} animation="wave" />
        <Box>
          <Skeleton variant="text" width={150} height={25} animation="wave" />
          <Skeleton variant="text" width={100} height={20} animation="wave" />
        </Box>
      </Box>

      {/* Top Summary Cards */}
      <Box display="flex" gap={2} flexWrap="wrap" mb={4}>
        {[...Array(5)].map((_, index) => (
          <Box key={index} sx={{ flex: '1 1 150px', minWidth: 150 }}>
            <Skeleton
              variant="rectangular"
              height={80}
              animation="wave"
              sx={{ borderRadius: '10px' }}
            />
          </Box>
        ))}
      </Box>

      {/* Table header skeleton */}
      <Box sx={{ mb: 1, mt: 2 }}>
        <Skeleton variant="text" width="20%" height={25} animation="wave" />
      </Box>

      {/* Table rows skeleton */}
      <Box>
        {[...Array(6)].map((_, i) => (
          <Box
            key={i}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              border: '1px solid #e0e0e0',
              borderRadius: '6px',
              padding: '10px 15px',
              mb: 1,
            }}
          >
            <Skeleton variant="text" width="25%" height={20} animation="wave" />
            <Skeleton variant="text" width="20%" height={20} animation="wave" />
            <Skeleton variant="text" width="15%" height={20} animation="wave" />
            <Skeleton variant="text" width="10%" height={20} animation="wave" />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ActivityLogsSkeleton;
